export const urlToken = '{URL}';
export const ErrorMessage = {
    DEFAULT: {
        copy: 'Sorry, this video is currently unavailable. Please try again.<br><br>Need additional help? Check out our troubleshooting tips ' + urlToken,
        urlId: '1',
        addError: true
    },
    '1': {
        copy: 'Sorry, this video is currently unavailable. Please try again.<br><br>Need additional help? Check out our troubleshooting tips ' + urlToken,
        urlId: '1',
        addError: true
    },
    '2': {
        copy: 'Oh no! It looks like you’re using a VPN or proxy, which prevents playing your video. Please disable this service and try again.<br><br>Need help? Visit ' + urlToken,
        urlId: '2',
        addError: true
    },
    '3': {
        copy: 'Sorry, but due to licensing restrictions, this video isn’t available in your location. ' + urlToken,
        urlId: '3',
        addError: true
    },
    '4': {
        copy: 'OOPS! We\'re having some trouble playing this video. Please try again. If you continue to experience issues, check your internet connection or restart your router.<br><br>Need help? Visit our ' + urlToken,
        urlId: '4',
        addError: true
    },
    '5': {
        copy: 'Oh no! This video can\'t be played right now. Please disable any ad-blocking software and try again.<br><br>Need help? Visit our ' + urlToken,
        urlId: '4',
        addError: true
    },
    '6': {
        copy: 'OOPS! Looks like the internet may be experiencing some issues. Please check your connection and try again. If you continue to experience issues, try restarting your router.<br><br>' + urlToken,
        urlId: '5',
        addError: true
    },
    OFFLINE: {
        copy: 'Oops, looks like you’re not connected to the internet.<br>Please check your connection and try again.',
        addError: false
    },
    '100': {
        copy: 'Oops! This video is not supported on your web browser.<br><br>To continue streaming, we recommend using the latest version of Chrome or Firefox.',
        addError: true
    },
    '110': {
        copy: 'Sorry, this video is currently unavailable.<br>Please refresh your page or try again later.',
        addError: true
    },
    '111': {
        copy: 'We were unable to load this video.<br/>Please check your browser/device settings for any blocking technology that needs to be disabled and reload the page.',
        addError: true
    },
    '112': {
        copy: 'This video is unavailable because we were unable to load a message from our sponsors.<br><br>Please exit private mode and reload the page to continue watching.',
        addError: true
    },
    '113': {
        copy: 'This video is unavailable because we were unable to load a message from our sponsors.' +
            '<br><br>' +
            'If you are using ad blocking software please disable it and reload the page. Or subscribe to ' +
            urlToken +
            ' to watch your favorite CBS shows and videos without commercials!',
        urlId: '6',
        addError: true
    },
    '114': {
        copy: 'This video is unavailable because we were unable to load a message from our sponsors.' +
            '<br><br>' +
            'If you are using ad blocking software please disable it and reload the page. Or upgrade to ' +
            urlToken +
            ' to watch your favorite CBS shows and videos without commercials!',
        urlId: '7',
        addError: true
    },
    '121': {
        copy: 'Sorry, this video is currently unavailable.<br>Please refresh your page or try again later.',
        addError: true
    },
    '122': {
        copy: 'Sorry, this video is currently unavailable.<br>Please refresh your page or try again later.',
        addError: true
    },
    '200': {
        copy: 'Sorry, this video is currently unavailable.<br>Please refresh your page or try again later.',
        addError: true
    }
};
